import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import PrivateRoute from '../Auth/PrivateRoute';
import ToolsInsideMenu from '../Common/TopMenu/Menu';
import Breadcrumbs from '../Common/Breadcrumbs';
import NewBreadcrumbs from '../Common/NewInsideMenu/Breadcrumbs';
import NewInsideMenu from '../Common/NewInsideMenu/Menu';
import EmbeddedMenu from '../Common/NewInsideMenu/EmbeddedMenu';
import './AppFrame.css';
import { Collapse, Dialog, DialogContent, LinearProgress } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import FileDeliveryService from '../../apiclients/FileDeliveryService';
import ContentService from '../../apiclients/ContentService';
import { getLocalizedName } from '../../helpers';
import AppContext from '../../AppContext';
import { Link } from 'react-router-dom';
import Search from '../Search/Search';
import * as cx from 'classnames';
import UserSettingsModal from '../Home/UserSettingsModal';
import PlatformChangerModal from '../Home/PlatformChangerModal';
import Icon, { IconButton } from '@projeccions-pdc/react-icon';
import { isDeviceOnline } from '../../helpers';
const menuIconSize = '20px';
const iconPlaceholderHeight = '42px';
const iconPlaceholderHeightSmartphone = '54px';
class AppFrame extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sidebarOpen: false,
            modalType: undefined,
            modalOpen: false,
            modalExtras: undefined,
            categories: [],
            breadCrumbs: [],
            editing: false,
            searchOpen: false,
            navigationOpen: false,
            loadingCategoryId: undefined,
        };
    }

    componentDidMount = async () => {
        let appContext = new AppContext();
        let language = appContext.getLanguage();
        if (appContext.getPlatformId() === 'brandhub') {
            let categories = [];
            const category = await this.loadCategory('');
            for (let c of category.children) {
                const cc = await this.loadCategory(c);
                categories.push({
                    contentId: c,
                    name: getLocalizedName(language, cc.names),
                    childrenIds: cc.children,
                    objectType: cc.objectType,
                });
            }
            this.setState({ categories }, async () => {
                for (let b of this.state.breadCrumbs) {
                    await this.handleClickChildrenOfCategory(b, true)();
                }
            });

            await this.refreshOnline();
        }
    };

    componentDidUpdate(prevProps) {
        if (
            this.props.currentContent &&
            prevProps.currentContent &&
            this.props.currentContent.contentId !== prevProps.currentContent.contentId
        ) {
            this.refreshOnline();
        }
    }
    refreshOnline = async () => {
        let isOnline = await isDeviceOnline();
        this.setState({ isOnline });
    };

    handleClickChildrenOfCategory =
        (contentId, force = undefined) =>
        async () => {
            let appContext = new AppContext();
            let language = appContext.getLanguage();
            let categories = cloneDeep(this.state.categories);

            if (force !== true) {
                this.setState({ loadingCategoryId: contentId });
            }
            this.setState({ categories: await this.recursivelyLoadChildrenOfCategory(contentId, categories, language, force) });
            if (force !== true) {
                this.setState({ loadingCategoryId: undefined });
            }
        };
    recursivelyLoadChildrenOfCategory = async (contentId, categories, language, force) => {
        try {
            for (let c of categories) {
                if (c.contentId === contentId) {
                    if (c.objectType === 'col' || c.objectType === 'mtg' || c.objectType === 'm') {
                        if (!force) {
                            this.props.history.push(`/metadocument/show/${c.contentId}`);
                        }
                    } else {
                        if (c.children === undefined) {
                            c.children = [];
                            for (let cc of c.childrenIds) {
                                const ccc = await this.loadCategory(cc);
                                c.children.push({
                                    contentId: cc,
                                    name: getLocalizedName(language, ccc.names),
                                    childrenIds: ccc.children,
                                    objectType: ccc.objectType,
                                });
                            }
                        }
                        c.opened = c.opened ? !c.opened || force : true;
                    }
                } else if (c.children && c.children.length > 0) {
                    c.children = await this.recursivelyLoadChildrenOfCategory(contentId, c.children, language, force);
                    c.opened =
                        c.children.filter((cc) => cc.opened === true).length > 0 ||
                        c.children.filter((cc) => cc.contentId === contentId).length > 0 ||
                        this.state.breadCrumbs.indexOf(c.contentId) !== -1;
                }
            }
        } catch (err) {}
        return categories;
    };

    componentWillReceiveProps = async (nextProps) => {
        if (this.props.currentContent !== nextProps.currentContent) {
            let contentId = cloneDeep(nextProps.currentContent.contentId);

            if (!contentId) {
                contentId = '';
            }
            const breadCrumbs = await this.getBreadCrumbs(contentId, nextProps.isInside);
            this.setState({ breadCrumbs });
            for (let b of breadCrumbs) {
                await this.handleClickChildrenOfCategory(b, true)();
            }
        }
    };

    getBreadCrumbs = async (contentId, inside) => {
        let breadcrumbs = [];
        let retry = 10;
        while (retry-- > 0 && contentId !== undefined && contentId !== null && contentId !== '') {
            let data;
            if (inside) {
                data = await FileDeliveryService.getContent(contentId);
            } else {
                data = await ContentService.getContent(contentId);
            }

            breadcrumbs.push(data.contentId);
            const ancestors = data.ancestors;
            if (ancestors && ancestors.length !== 0) {
                contentId = ancestors[0];
            } else {
                contentId = undefined;
            }
        }
        return breadcrumbs.reverse();
    };

    loadCategory = async (contentId) => {
        let data;
        if (this.props.isInside) {
            data = await FileDeliveryService.getContent(contentId);
        } else {
            data = await ContentService.getContent(contentId);
        }
        return data;
    };

    renderNavCategory = (content, level) => {
        const colors = ['#99C8CE', '#B3D9DD', '#CCEBEE', '#E6F5F7', '#F0FAFB'];
        try {
            if (level === undefined) level = 1;
            if (content.objectType === 'col' || content.objectType === 'mtg' || content.objectType === 'm') {
                return (
                    <Link
                        key={content.contentId}
                        className={'cm-metadocument'}
                        style={{
                            paddingLeft: `${16 + level * 4}px`,
                            paddingRight: `16px`,
                            // backgroundColor:
                            //     this.props.currentContent.contentId === content.contentId ||
                            //     this.state.breadCrumbs.indexOf(content.contentId) !== -1
                            //         ? '#99C8CE'
                            //         : undefined,
                            marginBottom: '0.2rem',
                            fontWeight:
                                this.props.currentContent.contentId === content.contentId ||
                                this.state.breadCrumbs.indexOf(content.contentId) !== -1
                                    ? 'bold'
                                    : undefined,
                        }}
                        onClick={() => this.setState({ navigationOpen: false })}
                        to={this.props.isInside ? '/metadocument/show/' + content.contentId : '/metadocument/edit/' + content.contentId}
                    >
                        <span dangerouslySetInnerHTML={{ __html: content.name }}></span>
                    </Link>
                );
            } else {
                return (
                    <>
                        <div
                            className={`cm-category ${content.opened === true ? 'cm-category-open' : 'cm-category-closed'}`}
                            onClick={this.handleClickChildrenOfCategory(content.contentId)}
                            dangerouslySetInnerHTML={{ __html: content.name }}
                            style={{
                                paddingLeft: `${16 + (level - 1) * 4}px`,
                                paddingRight: `16px`,
                                marginBottom: '0.2rem',
                            }}
                        ></div>
                        {content.children && (
                            <Collapse in={content.opened === true || this.state.breadCrumbs.indexOf(content.contentId) !== -1}>
                                <div className="cm-subcategories" style={{ backgroundColor: colors[level % 4] }}>
                                    {content.children.map((c) => this.renderNavCategory(c, level + 1))}
                                </div>
                            </Collapse>
                        )}
                        {content.children === undefined && this.state.loadingCategoryId === content.contentId && (
                            <div
                                className="cm-subcategories"
                                style={{ backgroundColor: colors[level % 4], paddingLeft: '0.4rem', paddingRight: '0.4rem' }}
                            >
                                <LinearProgress />
                            </div>
                        )}
                    </>
                );
            }
        } catch (err) {
            return <> </>;
        }
    };

    onEditingChange = (newEditing) => {
        this.setState({ editing: newEditing });
    };

    handleOpenResource = (resource, evt, source) => {
        if (resource.resourceType === 'content') {
            this.setState({ searchOpen: false });
        }
        this.props.onOpenResource(resource, evt, source);
    };

    handleToggleSearch = () => {
        this.setState({ searchOpen: !this.state.searchOpen });
    };

    onNavigationOpenChange = () => {
        this.setState({ navigationOpen: !this.state.navigationOpen });
    };

    render() {
        let appContext = new AppContext();
        let config = appContext.getConfig();
        //     .breadcrumbs-scrollUp {
        //     top: 0px;
        //     background-color: #fffc;
        //     transition: all 0.3s ease-in;
        // }
        return (
            <div>
                <div className="fe-menu">
                    {appContext.getPlatformId() === 'brandhub' && (
                        <>
                            <div
                                className={cx(
                                    { 'cm-container': true },
                                    { 'cm-container-open': this.state.navigationOpen }
                                    // { 'cm-container-scrollUp': !this.props.scrollTop }
                                )}
                            >
                                {/* <div className="cm-container-header"> */}
                                <div
                                    className="cm-logo"
                                    style={{
                                        backgroundImage: `url(${config.PlatformConfiguration}platform-config/default/nav-logo.png)`,
                                    }}
                                >
                                    {/* <img className="cm-logo" src={`${config.PlatformConfiguration}platform-config/default/nav-logo.png`} /> */}
                                </div>
                                {/* </div> */}
                                {this.state.categories.map((c) => this.renderNavCategory(c))}
                            </div>
                            <div className={cx({ 'embedded-menu': true }, { 'embedded-menu-open': this.state.navigationOpen })}>
                                <IconButton
                                    // name="fa-search"
                                    name="fa-search"
                                    primaryColor={'#000'}
                                    size={'24px'}
                                    padding={8}
                                    onClick={this.handleToggleSearch}
                                />
                                <UserSettingsModal
                                    notify={this.props.notify}
                                    isOnline={this.state.isOnline}
                                    fullWidth={false}
                                    iconPlaceholderHeight={
                                        this.state.smartphoneView !== true ? iconPlaceholderHeight : iconPlaceholderHeightSmartphone
                                    }
                                >
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <IconButton
                                            name="fa-user"
                                            primaryColor={'#000'}
                                            padding={10}
                                            size={menuIconSize}
                                            onClick={console.log}
                                        />
                                    </div>
                                </UserSettingsModal>
                                <PlatformChangerModal
                                    fullWidth={false}
                                    iconPlaceholderHeight={
                                        this.state.smartphoneView !== true ? iconPlaceholderHeight : iconPlaceholderHeightSmartphone
                                    }
                                >
                                    <IconButton
                                        name="fa-exchange"
                                        primaryColor={'#000'}
                                        size={menuIconSize}
                                        padding={10}
                                        onClick={console.log}
                                    />
                                </PlatformChangerModal>
                            </div>
                        </>
                    )}
                    {this.props.isInside === true ? (
                        appContext.getPlatformId() === 'brandhub' ? (
                            <EmbeddedMenu
                                isInside={this.props.isInside}
                                currentContent={this.props.currentContent}
                                notify={this.props.notify}
                                scrollUp={this.props.scrollUp}
                                history={this.props.history}
                                onMenuOpenToggle={this.onNavigationOpenChange}
                                // scrollTop={this.props.scrollTop}
                            />
                        ) : (
                            <NewInsideMenu
                                isInside={this.props.isInside}
                                currentContent={this.props.currentContent}
                                notify={this.props.notify}
                                scrollUp={this.props.scrollUp}
                                history={this.props.history}
                                // scrollTop={this.props.scrollTop}
                            />
                        )
                    ) : (
                        <ToolsInsideMenu
                            isInside={this.props.isInside}
                            currentContent={this.props.currentContent}
                            notify={this.props.notify}
                        />
                    )}
                    <Dialog open={this.state.searchOpen} fullWidth={true} maxWidth={'lg'} onClose={this.handleToggleSearch}>
                        <DialogContent style={{ minHeight: '300px' }}>
                            <Search
                                notify={this.props.notify}
                                editing={this.state.editing}
                                onEditingChange={this.onEditingChange}
                                searchStyle={{
                                    field: {
                                        color: '#000',
                                        width: this.state.editing === true ? '100%' : '100%',
                                    },
                                    iconStyle: {
                                        color: '#000',
                                        size: '32px',
                                    },
                                }}
                                onResultSelected={this.handleOpenResource}
                                disabled={false}
                                theme={undefined}
                                containerStyle={{
                                    display: 'inline-block',
                                    width: '100%',
                                }}
                            />
                        </DialogContent>
                    </Dialog>
                    {this.props.isTool === true ? (
                        ''
                    ) : this.props.isInside === true ? (
                        <PrivateRoute
                            path={'/:func?/:action?/:contentId?'}
                            exact
                            component={NewBreadcrumbs}
                            inside={this.props.isInside}
                            preDefinedPath={this.state.preDefinedPath}
                            scrollUp={this.props.scrollUp}
                            scrollTop={this.props.scrollTop}
                            compactOpen={this.state.navigationOpen}
                        />
                    ) : (
                        <PrivateRoute
                            path={'/:func?/:action?/:contentId?'}
                            exact
                            component={Breadcrumbs}
                            inside={this.props.isInside}
                            preDefinedPath={this.state.preDefinedPath}
                        />
                    )}
                </div>
                {this.props.children}
            </div>
        );
    }
}
AppFrame.propTypes = {
    isInside: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    currentContent: PropTypes.object,
    isTool: PropTypes.bool,
    notify: PropTypes.func.isRequired,
    scrollUp: PropTypes.bool,
    scrollTop: PropTypes.bool,
    history: PropTypes.object,
    onOpenResource: PropTypes.func,
};
AppFrame.contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired,
        }).isRequired,
        staticContext: PropTypes.object,
    }).isRequired,
};

export default withRouter(AppFrame);
